import { useEffect, useState } from 'react';

/**
 * Tracks the rendered width of an element, updating on resize when ResizeObserver exists.
 * The ref is a callback ref: the element may mount after the hook does (a chart that replaces
 * its skeleton once its data arrives) and is measured whenever it appears.
 */
export const useElementWidth = <T extends HTMLElement = HTMLDivElement>() => {
  const [element, setElement] = useState<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!element) return undefined;

    const updateWidth = () => setWidth(element.clientWidth);
    updateWidth();
    if (typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(updateWidth);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return { ref: setElement, width };
};
